import createTestId, { getTestId } from "../../../../fabrics/createTestId";

const HEADER_SHOW_ALL_PREFIX = "header-show-all";

export const HEADER_SHOW_ALL_TEST_ID = getTestId(HEADER_SHOW_ALL_PREFIX);

export const createTestIdForHeaderShowAll = createTestId(
    HEADER_SHOW_ALL_PREFIX,
);
